import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { CheckoutFormSchema } from '../schema';

interface IProps {
  onBack: () => void;
}

export default function StepAdditionalInformation(props: IProps) {
  const { t } = useTranslation();
  const { control, register, formState } = useFormContext<CheckoutFormSchema>();

  const shippingId = useWatch({ control, name: 'shippingMethodId' });
  const paymentId = useWatch({ control, name: 'paymentMethodId' });

  return (
    <div className="additional w-full flex flex-col gap-y-8">
      <div className="form-field mt-4">
        <label htmlFor="note">{t('OrderNote')}</label>
        <div className="input">
          <textarea {...register('note')} id="note" className="w-full h-24"></textarea>
        </div>
      </div>

      <div className="flex justify-between">
        <button type="button" className="btn btn-dark" onClick={props.onBack}>
          {t('GoBack')}
        </button>
        <button
          type="submit"
          className="btn btn-primary w-full max-w-[16rem] disabled:opacity-50"
          disabled={!shippingId || !paymentId}>
          {t('ToContinue')}
        </button>
      </div>
    </div>
  );
}
